import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_form_input = _resolveComponent("b-form-input");
  const _component_b_button = _resolveComponent("b-button");
  const _component_b_input_group_append = _resolveComponent("b-input-group-append");
  const _component_b_icon = _resolveComponent("b-icon");
  const _component_b_input_group_text = _resolveComponent("b-input-group-text");
  const _component_b_form_invalid_feedback = _resolveComponent("b-form-invalid-feedback");
  const _component_b_input_group = _resolveComponent("b-input-group");
  const _component_b_form_group = _resolveComponent("b-form-group");
  const _component_b_card_text = _resolveComponent("b-card-text");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_card = _resolveComponent("b-card");
  return _openBlock(), _createBlock(_component_b_card, {
    "no-body": "",
    "border-variant": $props.color,
    header: "Coupon Code",
    "header-bg-variant": $props.color
  }, {
    default: _withCtx(() => [!$props.discount || !$props.discount.id ? (_openBlock(), _createBlock(_component_b_card_text, {
      key: 0,
      class: "m-3"
    }, {
      default: _withCtx(() => [_cache[4] || (_cache[4] = _createTextVNode(" Enter a promotion or discount code below if you have one. ", -1)), _cache[5] || (_cache[5] = _createElementVNode("hr", null, null, -1)), _createVNode(_component_b_form_group, {
        label: "Code"
      }, {
        default: _withCtx(() => [_createVNode(_component_b_input_group, null, {
          default: _withCtx(() => [_createVNode(_component_b_form_input, {
            type: "text",
            modelValue: _ctx.code,
            "onUpdate:modelValue": [_cache[0] || (_cache[0] = $event => _ctx.code = $event), _cache[1] || (_cache[1] = $event => {
              _ctx.codeValid = false;
              _ctx.codeErrorMessage = null;
            })],
            modelModifiers: {
              lazy: true
            },
            state: !_ctx.codeValid && _ctx.codeErrorMessage ? false : null,
            placeholder: "Enter Code",
            disabled: _ctx.searchCode
          }, null, 8, ["modelValue", "state", "disabled"]), _withDirectives(_createVNode(_component_b_input_group_append, null, {
            default: _withCtx(() => [_createVNode(_component_b_button, {
              variant: "info",
              disabled: !_ctx.code || !_ctx.code.length,
              onClick: _withModifiers($options.checkCode, ["prevent"])
            }, {
              default: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode("Check Code", -1)]))], undefined, true),
              _: 1
            }, 8, ["disabled", "onClick"])], undefined, true),
            _: 1
          }, 512), [[_vShow, !_ctx.searchCode]]), _withDirectives(_createVNode(_component_b_input_group_append, null, {
            default: _withCtx(() => [_createVNode(_component_b_input_group_text, null, {
              default: _withCtx(() => [_createVNode(_component_b_icon, {
                icon: "arrow-repeat",
                animation: "spin"
              })], undefined, true),
              _: 1
            })], undefined, true),
            _: 1
          }, 512), [[_vShow, _ctx.searchCode]]), !_ctx.codeValid ? (_openBlock(), _createBlock(_component_b_form_invalid_feedback, {
            key: 0
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.codeErrorMessage), 1)], undefined, true),
            _: 1
          })) : _createCommentVNode("", true)], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true), $props.discount && $props.discount.id ? (_openBlock(), _createBlock(_component_b_card_text, {
      key: 1,
      class: "m-3"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, null, {
          default: _withCtx(() => [_createElementVNode("h3", null, [_createTextVNode(_toDisplayString($props.discount.discount.name) + " ", 1), _createElementVNode("button", {
            type: "button",
            class: "btn btn-sm btn-danger",
            onClick: _cache[2] || (_cache[2] = $event => $options.clearDiscount())
          }, [...(_cache[6] || (_cache[6] = [_createElementVNode("span", {
            class: "glyphicon glyphicon-remove"
          }, null, -1), _createTextVNode(" Remove ", -1)]))])]), _cache[7] || (_cache[7] = _createElementVNode("hr", null, null, -1))], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      }), _createVNode(_component_b_row, null, {
        default: _withCtx(() => [_createVNode(_component_b_col, null, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString($props.discount.discount.percent) + "% off your subscription! ", 1), $props.discount.discount.startdate !== null ? (_openBlock(), _createElementBlock("div", _hoisted_1, " This code will create a subscription that will be valid from " + _toDisplayString($props.discount.discount.startdate) + " to " + _toDisplayString($props.discount.discount.enddate), 1)) : _createCommentVNode("", true)], undefined, true),
          _: 1
        })], undefined, true),
        _: 1
      })], undefined, true),
      _: 1
    })) : _createCommentVNode("", true)], undefined, true),
    _: 1
  }, 8, ["border-variant", "header-bg-variant"]);
}